import type { RouteRecordRaw } from 'vue-router';

import { campaignRoutes } from '@/modules/common/route/constants';

const CampaignsList = () => import('@/modules/campaigns/views/CampaignsList/CampaignsList.vue');
const CampaignWrapper = () => import('@/modules/campaigns/views/CampaignEditor/CampaignWrapper.vue');
const CampaignSummaryPage = () => import('@/modules/campaigns/views/Summary/CampaignSummaryPage.vue');
const TargetGroupPage = () => import('@/modules/campaigns/views/TargetGroup/TargetGroupPage.vue');
const CreativeGroup = () => import('@/modules/campaigns/views/CreativeGroup/CreativeGroupPage.vue');
const AdGroupPage = () => import('@/modules/campaigns/views/AdGroup/AdGroupPage.vue');

type RouteGrants = {
  list: Array<number>;
  roles: Array<string>;
};

type RouteMeta = {
  roles?: Array<string>;
  grants?: RouteGrants;
  title?: string;
  icon?: string;
  alias?: string;
  layout?: string;
  transitionGroup?: string;
  bootstrap?: boolean;
};

type AppRouteRecord = RouteRecordRaw & {
  hidden?: boolean;
  meta?: RouteMeta;
  children?: Array<AppRouteRecord>;
};

const POC_ROLES = process.env.FF_CAMPAIGNS_POC_ADVERTISER
  ? ['advertiser', 'advert-admin', 'manager']
  : ['advert-admin', 'manager'];

// dict_user_grants id for `campaignsPoc.access` (see migration 411). Per-user override of the role gate above:
// an advertiser without the FF still gets in if they hold this grant.
const ACCESS_CAMPAIGNS_POC = 33;
const POC_GRANTS: RouteGrants = { list: [ACCESS_CAMPAIGNS_POC], roles: ['advertiser'] };

const campaignPocRoutes: Array<AppRouteRecord> = [
  {
    path: '/campaigns-poc',
    component: CampaignsList,
    name: campaignRoutes.list,
    meta: {
      roles: POC_ROLES,
      grants: POC_GRANTS,
      title: 'Campaigns POC',
      icon: 'hp-campaign',
      alias: 'cmp',
      bootstrap: false,
    },
  },
  // Campaign editor routes: /campaigns-poc/:id/summary, /campaigns-poc/:id/targets/:targetId, etc.
  {
    path: '/campaigns-poc/:id',
    hidden: true,
    component: CampaignWrapper,
    name: campaignRoutes.index,
    meta: {
      layout: 'campaign',
      roles: POC_ROLES,
      grants: POC_GRANTS,
      title: 'Campaign POC',
      bootstrap: false,
    },
    redirect: { name: campaignRoutes.summary },
    children: [
      {
        path: 'summary',
        component: CampaignSummaryPage,
        name: campaignRoutes.summary,
        meta: {
          title: 'Campaign Summary',
          transitionGroup: 'campaign-poc-editor',
        },
      },
      {
        path: 'targets/:targetId',
        component: TargetGroupPage,
        name: campaignRoutes.targetGroup,
        meta: {
          title: 'Target Details',
          transitionGroup: 'campaign-poc-editor',
        },
      },
      {
        path: 'creatives/:creativeId',
        component: CreativeGroup,
        name: campaignRoutes.creativeGroup,
        meta: {
          title: 'Creative Details',
          transitionGroup: 'campaign-poc-editor',
        },
      },
      {
        path: 'ads/:adId',
        component: AdGroupPage,
        name: campaignRoutes.adGroup,
        meta: {
          title: 'Ad Details',
          transitionGroup: 'campaign-poc-editor',
        },
      },
    ],
  },
];

export default campaignPocRoutes;
